module.exports = __webpack_public_path__ + "img/Dantam Hair 17.403ee671.jpg";